var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAvatar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 222,
  height: 223,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#avatar_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#EDEAE0",
  d: "M0 .25h222v222H0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 110.5,
  cy: 83.75,
  r: 42.5,
  fill: "#B0AA9A"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B0AA9A",
  d: "M33 196.25c0-33.137 26.863-60 60-60h35c33.137 0 60 26.863 60 60v26H33v-26Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "avatar_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .25h222v222H0z"
})))));
export { SvgAvatar as ReactComponent };
export default __webpack_public_path__ + "static/media/avatar.849f1dfa8abbb9fe7987.svg";